import React, { useState, useEffect } from 'react';
import './bookingHeader.css';
import { useDispatch, useSelector } from "react-redux";
import {
    copyWeekBookingSagaAction,
    getWeekBookingSagaAction
} from "../../../redux/sagaActions";

const BookingHeader = () => {
    const dispatch = useDispatch();
    const currentEstablishment = useSelector(state => state.currentEstablishment);
    const weekBooking = useSelector(state => state.weekBooking);

    // Состояние недель для копирования (открыты / закрыты)
    const [weeks, setWeeks] = useState(false);
    // Состояние календаря
    const [openCalendar, setOpenCalendar] = useState(false);

    const clickHandler = (event) => {
        if (!event.target.closest('.booking__copy-day')) {
            setWeeks(false);
        }
    };

    useEffect(() => {
        document.querySelector('.layout').addEventListener('click', clickHandler);

        return () => {
            document.querySelector('.layout').removeEventListener('click', clickHandler);
        };
    }, []);

    return (
        <>
            <div className="booking__date">
                <div className="booking__date-move booking__date-move--prev"
                     onClick={ () => dispatch(getWeekBookingSagaAction({
                         establishment: currentEstablishment,
                         date: weekBooking.prev
                     })) }
                />
                <div className="booking__week-calendar">
                    { weekBooking.week }
                    {
                        weekBooking.not_current_week &&
                        <div className="booking__week-today">
                            <span onClick={ () => {
                                dispatch(getWeekBookingSagaAction({
                                    establishment: currentEstablishment,
                                    data: weekBooking.today
                                }));
                            } }>Текущая неделя</span>
                        </div>
                    }
                </div>
                <div className="booking__date-move booking__date-move--next"
                     onClick={ () => dispatch(getWeekBookingSagaAction({
                         establishment: currentEstablishment,
                         date: weekBooking.next
                     })) }
                />
            </div>
            <div className="booking__refresh"
                onClick={ () => dispatch(getWeekBookingSagaAction({
                    establishment: currentEstablishment,
                    date: weekBooking.date
                })) }
            >Обновить</div>
            <div className="booking__copy-day">
                <div className="booking__copy-button"
                     onClick={ () => {
                         setWeeks(!weeks);
                     } }
                >Скопировать неделю</div>
                <div className={ `dropdown__items ${ weeks ? 'dropdown__items--open' : '' }` }>
                    {
                        weekBooking.next_weeks?.map((w, index) => {
                            return (
                                <div className="dropdown__item" key={ index }
                                     onClick={ () => {
                                         dispatch(copyWeekBookingSagaAction({
                                             current_week: weekBooking.current_week,
                                             copy_days: JSON.stringify(w.days)
                                         }));
                                         setWeeks(false);
                                     } }
                                >
                                    { w.from_formatted + ' − ' + w.to_formatted  }
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        </>
    );
};

export default BookingHeader;